/** @jsx jsx */
import { graphql } from "gatsby"
import { jsx, Flex, Heading, Container } from "theme-ui"
import Hero from "../component/hero"
import ImageWithZoom from "../component/image-list"
import Layout from "../component/layout"
import ProjectInfo from "../component/project-info"
import { MDXRenderer } from "gatsby-plugin-mdx"

const Project = ({ data }) => {
  const {
    mdx,
    allFile: { edges: images },
  } = data
  const { frontmatter: project } = mdx

  return (
    <Layout>
      <Hero image={project.cover.childImageSharp.fluid}>
        <Flex
          sx={{
            position: `absolute`,
            bottom: 0,
            left: 0,
            right: 0,
            maxWidth: `6xl`,
            margin: `0 auto`,
            padding: 4,
            zIndex: 2,
            flexDirection: `column`,
          }}
        >
          <Heading as="h1" variant="styles.h1">
            {project.title}
          </Heading>
          <ProjectInfo project={project} />
          <div
            sx={{
              textTransform: `uppercase`,
              color: `primary`,
              letterSpacing: `wider`,
              fontWeight: `semibold`,
            }}
          >
            Description
          </div>
          <MDXRenderer>{mdx.body}</MDXRenderer>
        </Flex>
      </Hero>
      <Container>
        {images.map(({ node }, i) => (
          <div key={i} sx={{ marginTop: "1rem" }}>
            <ImageWithZoom node={node} slug={project.slug} />
          </div>
        ))}
      </Container>
    </Layout>
  )
}

export default Project

export const query = graphql`
  query($slug: String!) {
    mdx(frontmatter: { slug: { eq: $slug } }) {
      frontmatter {
        slug
        title
        cover {
          childImageSharp {
            fluid(maxWidth: 1920, quality: 90) {
              ...GatsbyImageSharpFluid_withWebp
            }
          }
        }
        tool
        date
      }
      body
    }
    allFile(
      filter: {
        relativeDirectory: { eq: $slug }
        extension: { eq: "jpg" }
        sourceInstanceName: { eq: "static" }
      }
      sort: { fields: [name], order: ASC }
    ) {
      edges {
        node {
          name
          childImageSharp {
            fluid(maxHeight: 780, quality: 90) {
              ...GatsbyImageSharpFluid
              ...GatsbyImageSharpFluidLimitPresentationSize
            }
          }
        }
      }
    }
  }
`
